import colors from 'shared/theme/base/colors';
import borders from 'shared/theme/base/borders';

const { inputColors } = colors;
const { borderWidth, borderRadius } = borders;

export default {
  styleOverrides: {},
};
